import {
  RESET_MSG_BOARD,
  HIT_BOARD_STATUS,
  GET_LIST_BOARD,
  GET_LIST_MEMBER_BOARD
} from "redux/actions/board";
import { publishStat } from "components/board/parts/CardBoard";
// REVAMP
import {
  HIT_BOARD_DELETEV2,
  HIT_BOARD_INFOV2,
  HIT_BOARD_STATUSV2
} from "_revamp/redux/action/admin/board";

const initialState = {
  data: [],
  member: [],
  status: "",
  message: "",
  listView: "",
  statusV2: "",
  messageV2: "",
  listViewV2: "",
  title: "",
  titleValue: "",
  button: ""
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_LIST_BOARD: {
      const copyArr = [...state.data];
      if (payload.board_id !== undefined) {
        const ind = copyArr.findIndex(x => x.board_id === payload.board_id);
        if (payload.visibility_status !== undefined) {
          copyArr[ind].visibility_status = payload.visibility_status;
          copyArr[ind].visibility_status_ket = publishStat(
            payload.visibility_status === 1 ? "Public" : "Private"
          );
        } else {
          copyArr[ind].publish_status = payload.publish_status;
          copyArr[ind].publish_status_ket = publishStat(payload.publish_status);
        }

        return {
          ...state,
          data: copyArr
        };
      }

      return {
        ...state,
        data: payload
      };
    }
    case HIT_BOARD_STATUS: {
      return {
        ...state,
        status: payload.status,
        message: payload.message,
        listView: payload.listView,
        tempData: payload?.tempData || null,
        button: payload?.button
      };
    }
    case HIT_BOARD_INFOV2:
    case HIT_BOARD_DELETEV2:
    case HIT_BOARD_STATUSV2: {
      return {
        ...state,
        statusV2: payload.statusV2,
        messageV2: payload.messageV2,
        listViewV2: payload.listViewV2,
        title: payload.title,
        titleValue: payload?.titleValue,
        tempDataV2: payload?.tempDataV2 || null
      };
    }
    case RESET_MSG_BOARD: {
      return {
        ...state,
        status: "",
        message: ""
      };
    }
    case GET_LIST_MEMBER_BOARD: {
      return {
        ...state,
        member: payload
      };
    }
    default:
      return state;
  }
};
